

exports.__esModule = true;
exports.$xoCardExpiryDirective = undefined;

var _squid = require('squid');

require('xo-ui-components/src/tooltip/directive');

require('xo-ui-components/src/error-tooltip/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoCardExpiryDirective = exports.$xoCardExpiryDirective = _squid.$Component.extend('$xoCardExpiryDirective', {
    tag: 'xo-card-expiry',
    template: _template2['default'],
    props: {
        expiryMonth: {
            type: 'var',
            required: false
        },
        expiryYear: {
            type: 'var',
            required: false
        }
    },
    lifecycle: {
        enter: function enter() {
            var _this = this;

            var format = (0, _squid.$feature)('ccExpiryDateFormat', 'MMYY', _squid.$locale.country);
            var regexPattern = format === 'MMYY' ? /(0\d|1[0-2])\/(\d{2})/ : /(0\d|1[0-2])\/(\d{4})/;

            var init = function init() {
                if (_this.expiryMonth && _this.expiryYear) {
                    _this.expiryDate = format === 'MMYY' ? _this.expiryMonth + '/' + _this.expiryYear.substring(2, 4) : _this.expiryMonth + '/' + _this.expiryYear;
                }
            };

            init();
            this.$watch('[expiryMonth, expiryYear]', function (expiryInfo) {
                if (expiryInfo && expiryInfo[0] && expiryInfo[1]) {
                    _this.expiryMonth = expiryInfo[0];
                    _this.expiryYear = expiryInfo[1];
                    init();
                }
            });

            $('#expiry_value').mask(format === 'MMYY' ? '00/00' : '00/0000');

            this.validate = function (expiryDate) {
                if (!expiryDate) {
                    return false;
                }

                var regexMatch = regexPattern.exec(expiryDate);

                if (!regexMatch) {
                    return false;
                }

                var today = new Date();
                var currentYear = today.getFullYear();
                var expMonth = Number(regexMatch[1]);
                var expYear = Number(regexMatch[2]);

                if (format === 'MMYY') {
                    // convert year from YY to YYYY format e.g currentYear = 2017, expYear = 20,
                    // result should be (2020) = (2017 - 17 + 20)
                    expYear = currentYear - currentYear % 100 + expYear;
                }

                var expDate = new Date(expYear, expMonth - 1);

                if (expDate < today) {
                    return false;
                }

                _this.expiryYear = expYear.toString();

                // expiryMonth need to have leading 0 for single digit month
                _this.expiryMonth = expMonth < 10 ? '0' + expMonth : expMonth.toString();

                return true;
            };
        }
    }
});

angular.value("$xoCardExpiryDirective", $xoCardExpiryDirective);
_squid.$Component;

_squid.$locale;

_squid.$feature;


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-wallet-components/src/add-card/cardExpiry/directive.js
// module id = ../node_modules/xo-wallet-components/src/add-card/cardExpiry/directive.js
// module chunks = 0